import { browser } from '$app/environment';
import { goto } from '$app/navigation';
import { session } from '$lib/PersistedState.svelte';

import type { LayoutLoad } from './$types';

import { datadogLogs } from '@datadog/browser-logs';

import { checkForAppUpdates } from '$lib/updater';

export const ssr = false;
export const prerender = false;

export const load = (async ({}) => {
  if (browser) {
    if (!session.hasToken) {
      goto('/login');
    }

    if (session.isExpired()) {
      datadogLogs.logger.warn('Token expired');
      goto('/login');
    }

    // @ts-ignore
    if (window.__TAURI_INTERNALS__) {
      console.log('Running in Tauri environment');
      datadogLogs.setGlobalContextProperty('isTauri', true);

      if (import.meta.env.PROD) {
        checkForAppUpdates();
      }
    } else {
      datadogLogs.setGlobalContextProperty('isTauri', false);
    }
  }
}) satisfies LayoutLoad;
